import { FacilityInfoRow } from "../externalStorageFacility.types";

interface FacilityViewInfoSectionProps {
  rows: FacilityInfoRow[];
}

const FacilityViewInfoSection = ({ rows }: FacilityViewInfoSectionProps) => (
  <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
    {rows.map(row => (
      <div key={row.label}>
        <p className="tw-text-xs tw-text-muted-foreground">{row.label}</p>
        <p className="tw-text-sm tw-text-foreground tw-break-words">{row.value}</p>
      </div>
    ))}
  </div>
);

export default FacilityViewInfoSection;
